export const statuses = "WorkOrderStatuses";

export const TECHNICIAN_IDENTITY = "technicianIdentity";
export const CUSTOMER_IDENTITY = "customerIdentity";
export const LOCATIONS = "locations";
export const TECHNICIANS = "woTechnicians";

export const FROMDATE = "workOrderCreationStartDate";
export const TODATE = "workOrderCreationEndDate";
export const SCHEDULE_FROM_DATE = "workOrderScheduleFromDate";
export const SCHEDULE_TO_DATE = "workOrderScheduleToDate";

export const DELIVERY_FROM_DATE = "workOrderDeliveryStartDate";
export const DELIVERY_TO_DATE = "workOrderDeliveryEndDate";

export const PICKUP_FROM_DATE = "workOrderPickupStartDate";
export const PICKUP_TO_DATE = "workOrderPickupEndDate";

export const VIEW = "view";
export const GENERIC_SEARCH = "searchString";

export const USER_IDENTITY = "userIdentity";

export const SELECTED_WO_statuses = "woStatuses";
export const SELECTED_WO_TECHS = "woTechs";
export const SELECTED_WO_LOCS = "woLocations";
export const SELECTED_WO_SALES = "woSalesPersons";
export const SELECTED_WO_PRIORITIES = "woPriorities";
export const INCLUDE_FINALIZED = "includeFinalized";

export const FILTER_CLOCKED_HOURS = "filterClockedHours";

export const FILTER_OVER_CLOCKED_HOURS = "filterOverClockedHours";

export const SELECTED_WO_CUSTOMERS = "woCustomers";

export const DEFAULT_SEARCH_INFO_ALERT = "defaultSearchInfoAlert";
export const LOGISTICS_SEARCH_INFO_ALERT = "logisticsSearchInfoAlert";
export const BOARD_ZOOM = "boardZoom";
export const COLLAPSE_WORK_ORDERS = "collapseWorkOrders";

// Technician Calendar filters
export const TECH_CALENDAR_LOCATION = "techCalendarLocation";
export const TECH_CALENDAR_TECHNICIANS = "techCalendarTechnicians";
export const TECH_CALENDAR_WEEK_OFFSET = "techCalendarWeekOffset";
export const TECH_CALENDAR_VIEW_MODE = "techCalendarViewMode";
export const TECH_CALENDAR_WO_STATUSES = "techCalendarWoStatuses";
export const TECH_CALENDAR_WO_DOC_STATUSES = "techCalendarWoDocStatuses";
export const TECH_CALENDAR_COLLAPSE_SCHEDULE_ITEMS =
  "techCalendarCollapseScheduleItems";
export const TECH_CALENDAR_WEEK_DAY_RANGE = "techCalendarWeekDayRange";